import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import './App.css';
import FileInput from './FileInput';
import MassHead from '../components/MassHead';

const mapStateToProps = (state) => ({

	hasBeenRead: state.parseExportFile.hasBeenRead
})

const mapDispatchToProps = (dispatch) => ({})

class App extends React.Component {

  render() {

  	const { hasBeenRead } = this.props;

    return (
      <div className="App">
        <MassHead hasBeenRead={hasBeenRead} />
        <FileInput />
       	{
       		hasBeenRead ?
       		<div className='tc mt2'>
       			<h2>Parsing successful!</h2>
       			<span>You may now download your desired content.</span>
       			<div className='ma3'>
			    	<NavLink exact className="link grow f6 f5-ns dib mr3 pv2 ph4" to="/wp-export-file-parser/menu" title="Download Menu">Download Menu</NavLink>
			    	<NavLink exact className="link grow f6 f5-ns dib mr3 pv2 ph4" to="/wp-export-file-parser/pages" title="Download Pages">Download Pages</NavLink>
                    <NavLink exact className="link grow f6 f5-ns dib mr3 pv2 ph4" to="/wp-export-file-parser/posts" title="Download Posts">Download Posts</NavLink>
			    </div>
       		</div>
       		: ''
       	}
        <div className='flex justify-start pa2'>
          <div className='w-75-ns f6'>
            <strong className='f3'>Instructions:</strong>
            <ol className="lh-copy">
              <li><strong>Export your content</strong>
                <ul>
                  <li>Login to the wordpress site you want to get content from.</li>
                  <li>Go to Admin > Tools > Export. <small className='red'>(if you don't see this, ask your site administrator.)</small></li>
                  <li>Select 'All Content' and click on Export. This will give you an XML export file.</li>
                </ul>
              </li>
              <li><strong>Let this tool read the file</strong>
                <ul>
                  <li>Click the 'Choose File' button above to select your file.</li>
                  <li>Click the 'Read Export File' button.</li>
                </ul>
              </li>
              <li><strong>Select the content you want</strong>
                <ul>
                  <li>Menu: all Menu.</li>
                  <li>Pages: you can select the pages you want to download.</li>
                  <li>Posts: you can select the posts you want to download.</li>
                </ul>
              </li>
              <li><strong>Click the download button</strong></li>
              <li><strong>Import to your site.</strong>
                <ul>
                  <li>Login to the wordpress site you wish to transfer content to.</li>
                  <li>Go to Admin > Tools > Import. <small className='red'>(if you don't see this, ask your site administrator.)</small></li>
                  <li>Follow the interface there to import.</li>
                </ul>
              </li>
            </ol>
            <h3>Notes:</h3>
            <ul className='lh-copy'>
              <li>Use Chrome to import your file. Hold CTRL(COMMAND on Mac) then click the import button.<br/>
              This will import on a new tab. If the import fails, just go back to the original tab and import again.</li>
              <li>When importing: Assign the author to yourself. This way, the import won't fail if you don't have the rights to add new authors to the site.</li>
            </ul>
          </div>
        </div>
      </div>
      )
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
